/* =============================================================
   STUDIO.JS — Tattooed Theory Studio Interactions
   Vanilla JS, no dependencies. Runs after DOMContentLoaded.
   ============================================================= */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     FAQ Accordion
  ---------------------------------------------------------- */
  function initFaqAccordion() {
    var questions = document.querySelectorAll('.studio-faq__question');
    if (!questions.length) return;

    questions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answerId = btn.getAttribute('aria-controls');
        var answer = answerId ? document.getElementById(answerId) : null;

        // Close all siblings in the same list
        var list = btn.closest('.studio-faq__list');
        if (list) {
          list.querySelectorAll('.studio-faq__question').forEach(function (sibling) {
            if (sibling === btn) return;
            sibling.setAttribute('aria-expanded', 'false');
            var sibId = sibling.getAttribute('aria-controls');
            var sibAnswer = sibId ? document.getElementById(sibId) : null;
            if (sibAnswer) sibAnswer.setAttribute('aria-hidden', 'true');
          });
        }

        btn.setAttribute('aria-expanded', String(!expanded));
        if (answer) answer.setAttribute('aria-hidden', String(expanded));
      });
    });
  }

  /* ----------------------------------------------------------
     Mobile Nav — Shop Dropdown Accordion
  ---------------------------------------------------------- */
  function initMobileNavDropdowns() {
    var toggles = document.querySelectorAll('.mobile-nav__dropdown-toggle');
    if (!toggles.length) return;

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var subId = btn.getAttribute('aria-controls');
        var sub = subId ? document.getElementById(subId) : null;

        btn.setAttribute('aria-expanded', String(!expanded));
        if (sub) sub.setAttribute('aria-hidden', String(expanded));
      });
    });
  }

  /* ----------------------------------------------------------
     Horizontal Scroll — drag to scroll on desktop
  ---------------------------------------------------------- */
  function initDragScroll() {
    var rails = document.querySelectorAll('.artist-card__gallery, .studio-work__strip, .artist-calendar__months');
    if (!rails.length) return;

    rails.forEach(function (el) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      el.addEventListener('pointerdown', function (e) {
        isDown = true;
        el.setPointerCapture(e.pointerId);
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
      });

      el.addEventListener('pointerup', function () {
        isDown = false;
      });

      el.addEventListener('pointercancel', function () {
        isDown = false;
      });

      el.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - el.offsetLeft;
        var walk = (x - startX) * 1.4;
        el.scrollLeft = scrollLeft - walk;
      });
    });
  }

  /* ----------------------------------------------------------
     Scroll Reveal — reuse existing .reveal pattern for studio
     sections (falls through to theme.js IntersectionObserver)
  ---------------------------------------------------------- */

  /* ----------------------------------------------------------
     Init
  ---------------------------------------------------------- */
  function init() {
    initFaqAccordion();
    initMobileNavDropdowns();
    initDragScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
